import React from 'react';
import { ZapIcon } from 'lucide-react';
import { trackPurchaseClick, trackContentEngagement } from './MetaPixelTracker';
export function Navbar() {
  const scrollToCallToAction = e => {
    e.preventDefault();
    trackContentEngagement('navigation', 'navbar_cta_button', 'click');
    // Find the element with the text "Ahora… solo hacelo real."
    const elements = document.querySelectorAll('p');
    for (const element of elements) {
      if (element.textContent?.includes('Ahora… solo hacelo real.')) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
        break;
      }
    }
  };
  return <nav className="bg-black/90 backdrop-blur-sm sticky top-0 z-50 border-b border-gray-800" data-id="element-358">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-359">
        <div className="flex justify-between h-16 items-center" data-id="element-360">
          <div className="flex items-center" onClick={() => trackContentEngagement('navigation', 'logo', 'click')} data-id="element-361">
            <ZapIcon className="h-8 w-8 text-red-500" data-id="element-362" />
            <span className="ml-2 text-xl font-bold text-white" data-id="element-363">ImpulseX</span>
          </div>
          <div data-id="element-364">
            <a href="#" className="bg-red-600 hover:bg-red-700 text-white py-1.5 px-4 rounded transition duration-300 flex items-center text-sm gap-1.5" onClick={e => {
            scrollToCallToAction(e);
            // Enhanced tracking for navigation
            if (window.fbq) {
              window.fbq('trackCustom', 'NavbarCTAClick', {
                button_text: 'Comprar Ahora',
                timestamp: new Date().toISOString()
              });
            }
          }} data-id="element-365">
              <span data-id="element-366">Comprar Ahora</span>
            </a>
          </div>
        </div>
      </div>
    </nav>;
}